import { navbar } from "../elements";

export function useNavbarCheck() {
  function addNoOverlap() {
    navbar.classList.add("navbar--no-overlap");
  }

  const post_password_form = document.querySelector(".post-password-form");

  if (post_password_form) {
    addNoOverlap();
  }
}
